import { render, staticRenderFns } from "./vendors-history--filters.vue?vue&type=template&id=1201a556&scoped=true&"
import script from "./vendors-history--filters.vue?vue&type=script&lang=js&"
export * from "./vendors-history--filters.vue?vue&type=script&lang=js&"
import style0 from "./vendors-history--filters.vue?vue&type=style&index=0&id=1201a556&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1201a556",
  null
  
)

export default component.exports